var _circle, _path, _path2, _circle2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 26,
    r: 20,
    fill: "#F5F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 23.5V31H18.75V23.5H21.25V31H23.75V23.5H26.25V31H27.6562C27.7806 31 27.8998 31.0494 27.9877 31.1373C28.0756 31.2252 28.125 31.3444 28.125 31.4688V32.25H11.875V31.4688C11.875 31.3444 11.9244 31.2252 12.0123 31.1373C12.1002 31.0494 12.2194 31 12.3438 31H13.75V23.5H16.25Z",
    fill: "#668598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.182 20.7113L20.1195 17.2738C20.043 17.2421 19.957 17.2421 19.8805 17.2738L10.818 20.7113C10.7609 20.7349 10.712 20.7749 10.6777 20.8263C10.6434 20.8777 10.625 20.9381 10.625 20.9999V21.6249C10.625 21.7078 10.6579 21.7873 10.7165 21.8459C10.7751 21.9045 10.8546 21.9374 10.9375 21.9374H11.875V22.4062C11.875 22.5305 11.9244 22.6497 12.0123 22.7376C12.1002 22.8255 12.2194 22.8749 12.3438 22.8749H27.6562C27.7806 22.8749 27.8998 22.8255 27.9877 22.7376C28.0756 22.6497 28.125 22.5305 28.125 22.4062V21.9374H29.0625C29.1454 21.9374 29.2249 21.9045 29.2835 21.8459C29.3421 21.7873 29.375 21.7078 29.375 21.6249V20.9999C29.375 20.9381 29.3566 20.8777 29.3223 20.8263C29.288 20.7749 29.2391 20.7349 29.182 20.7113ZM28.4375 32.8749H11.5625C11.3139 32.8749 11.0754 32.9737 10.8996 33.1495C10.7238 33.3253 10.625 33.5638 10.625 33.8124V34.4374C10.625 34.5203 10.6579 34.5998 10.7165 34.6584C10.7751 34.717 10.8546 34.7499 10.9375 34.7499H29.0625C29.1454 34.7499 29.2249 34.717 29.2835 34.6584C29.3421 34.5998 29.375 34.5203 29.375 34.4374V33.8124C29.375 33.5638 29.2762 33.3253 29.1004 33.1495C28.9246 32.9737 28.6861 32.8749 28.4375 32.8749Z",
    fill: "#668598"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 8.25,
    fill: "#668598",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.753 8.5H35.3775V7.375C35.3775 6.06562 34.3106 5 32.9995 5C31.6885 5 30.6215 6.06562 30.6215 7.375V8.5H30.2461C29.8315 8.5 29.4951 8.83594 29.4951 9.25V12.25C29.4951 12.6641 29.8315 13 30.2461 13H35.753C36.1676 13 36.504 12.6641 36.504 12.25V9.25C36.504 8.83594 36.1676 8.5 35.753 8.5ZM34.126 8.5H31.8731V7.375C31.8731 6.75469 32.3784 6.25 32.9995 6.25C33.6206 6.25 34.126 6.75469 34.126 7.375V8.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/BankIcon.3e99fed5.svg";
export { ForwardRef as ReactComponent };